package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors
import kotlin.math.roundToInt

/**
 * Segmented pixel HP bar — the signature element of the redesign.
 * Shows 1 cell per HP up to 16, then caps at 16 cells (so high-level chars don't overflow).
 */
@Composable
fun PixelHpBar(cur: Int, max: Int, modifier: Modifier = Modifier, height: Dp = 12.dp) {
    val pct = if (max > 0) (cur.toFloat() / max).coerceIn(0f, 1f) else 0f
    val segs = max.coerceIn(4, 16)
    val filled = (pct * segs).roundToInt()
    val fill = when {
        pct > 0.5f  -> BrandColors.Ember
        pct > 0.25f -> BrandColors.EmberAmber
        else        -> BrandColors.EmberDim
    }
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(height)
            .background(BrandColors.Vault, RoundedCornerShape(3.dp))
            .border(1.dp, BrandColors.Slate.copy(alpha = 0.4f), RoundedCornerShape(3.dp))
            .padding(2.dp),
        horizontalArrangement = Arrangement.spacedBy(2.dp),
    ) {
        repeat(segs) { i ->
            Box(
                Modifier
                    .weight(1f)
                    .fillMaxHeight()
                    .background(
                        if (i < filled) fill else BrandColors.StoneLight,
                        RoundedCornerShape(1.dp),
                    )
            )
        }
    }
}
